import {
  AutoRefreshTokenService,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { environment } from '../environments/environment';

/**
 * Configuration of URLs that will receive the Bearer token
 * Matches all STEF Connect environments and localhost for dev
 */
const includeBearerTokenCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /^(https?:\/\/(devb|recb)?\.?stefconnect\.stef\.com|http:\/\/localhost:8080)/i,
  bearerPrefix: 'Bearer',
});

/**
 * Keycloak configuration for the application
 */
export const provideKeycloakConfig = () =>
  provideKeycloak({
    config: {
      url: environment.keycloak.url,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: globalThis.location.origin + '/silent-check-sso.html',
      checkLoginIframe: false,
    },
    features: [withAutoRefreshToken({ onInactivityTimeout: 'login' })],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [includeBearerTokenCondition],
      },
    ],
  });
